import TableCell, { TableCellProps } from '@mui/material/TableCell'

export interface IAcTableCell extends TableCellProps {
  children: React.ReactNode
}

export const AcTableCell = ({ children, ...props }: IAcTableCell) => {
  return <TableCell {...props}>{children}</TableCell>
}
